import { useMemo } from "react";
import dayjs, { Dayjs } from "dayjs";

type DateInput = string | Date | Dayjs;

export interface LeaseDuration {
  years: number;
  months: number;
  days: number;
  label: string;
}

export function useGetLeaseDuration(startDate?: DateInput, endDate?: DateInput): LeaseDuration {
  return useMemo(() => {
    if (!startDate || !endDate) {
      return { years: 0, months: 0, days: 0, label: "" };
    }

    let start = dayjs(startDate);
    let end = dayjs(endDate).add(1, "day");

    if (start.isAfter(end)) {
      [start, end] = [end, start];
    }

    const years = end.diff(start, "year");
    start = start.add(years, "year");

    const months = end.diff(start, "month");
    start = start.add(months, "month");

    const days = end.diff(start, "day");

    const label = [
      years && `${years} year${years > 1 ? "s" : ""}`,
      months && `${months} month${months > 1 ? "s" : ""}`,
      days && `${days} day${days > 1 ? "s" : ""}`,
    ]
      .filter(Boolean)
      .join(" ");

    return { years, months, days, label };
  }, [startDate, endDate]);
}
